/**
 * App entry point. Order of wrappers (outermost first):
 *   StrictMode → Redux Provider → AppInitWrapper (Katal init) → Suspense → App
 * The Redux Provider must wrap everything that calls useAppSelector /
 * useAppDispatch / RTK Query hooks — i.e. the whole app.
 */

import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import Spinner from '@amzn/awsui-components-core/spinner';

import { store } from './app/store';
import App from './components/App';
import AppInitWrapper from './components/AppInitWrapper';
import './monitoring';

import '@amzn/awsui-global-styles/polaris.css';
import './index.scss';

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <StrictMode>
    <Provider store={store}>
      <AppInitWrapper>
        <Suspense fallback={<Spinner size="large" />}>
          <App />
        </Suspense>
      </AppInitWrapper>
    </Provider>
  </StrictMode>,
);
